/**
 * Created by Shem.Mahluf on 22/08/2017.
 */

import PropTypes from 'prop-types';

import React from 'react';
import {connect} from 'react-redux';
import appC from '../../constants/app';
import routesC from '../../constants/routes';
import {axiosInstance} from '../../utils/helpers';
import * as AlertActions from '../../actions/alert';
import {bindActionCreators} from 'redux';
import intlC from '../../constants/intl';


const Authorize = (WrappedComponent) => {
    class Authorization extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                authorized: false
            }
        }

        permissionsValidate(){
            const permissionsMap = {
                [routesC.SR_PATH]: 'submitRequestEnabled',
                [routesC.INCIDENT_PATH]: 'reportIssueEnabled',
                [routesC.FAQ_PATH_PARAM]: 'faqEnabled',
                [routesC.FAQ_PATH]: 'faqEnabled',
                [routesC.MY_SETTINGS_PATH]: 'endUserCanChangeSettings',
                [routesC.SEARCH_RESULT]: 'searchEnabled',
                [routesC.SERVICE_CATALOG_PATH_PARAM]: 'serviceCatalogEnabled'
            };
            let currentPath;
            if (this.props.match) {
                currentPath = this.props.match.path;
            } else {
                currentPath = this.props.location.pathname;
            }

            if (this.props.permissions.isFetched) {
                // already received permissions from server, check inside store
                let StorePermissions = this.props.permissions;
                if (StorePermissions[permissionsMap[currentPath]] === false) {
                    // No permission, redirect to login.
                    let alertData = {
                        alertIcon: 'errorIcon',
                        // if accessing the route directly, and intl object isnt ready add english default title
                        alertTitle: alertData =  this.props.intlObject['ssp.alert.form.submit.sr.nopermission'] ? this.props.intlObject['ssp.alert.form.submit.sr.nopermission'] : 'You do not have permissions to view this',
                        alertText: '',
                        alertStyle: 'danger',
                        displayTime: 3000
                    };
                    this.props.alertActions.initAlert(alertData);
                    this.props.history.push(routesC.ROOT_PATH);
                } else {
                    this.setState({authorized: true});
                }
            } else {
                // fetch permissions from server and decide
                axiosInstance.get('api/v1/sc/permissions').then((response) => {
                    if (response.data[permissionsMap[currentPath]] === false) {
                        // No permission, redirect to login.
                        this.props.history.push(routesC.ROOT_PATH);
                    } else {
                        this.setState({authorized: true});
                    }
                });
            }
        }

        componentWillMount() {
            this.permissionsValidate();
        }

        componentWillReceiveProps() {
            this.permissionsValidate();
        }

        render() {
            if (this.state.authorized) {
                return <WrappedComponent {...this.props} />
            } else {
                return null;
            }
        }
    }

    Authorization.propTypes = {
        permissions: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        match: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        alertActions: PropTypes.object.isRequired,
        intlObject: PropTypes.object.isRequired
    };

    function mapStateToProps(state) {
        return {
            permissions: state.app.get(appC.SSP_PERMISSIONS_LIST),
            intlObject: state.intl.get(intlC.INTL_OBJECT)
        };
    }

    function mapDispatchToProps(dispatch) {
        return {
            alertActions: bindActionCreators(AlertActions, dispatch)
        }
    }

    return connect(mapStateToProps, mapDispatchToProps)(Authorization);
};

export default Authorize;


// WEBPACK FOOTER //
// ./containers/Authorization/index.js